import { makeStyles } from "@material-ui/core";
import { colors } from "../../../assets/colors";

export const useStyles = makeStyles(()=>({
    circularProgress: {
        color: colors.text2,
        padding: 4
    },
}))